export var Direction;
(function (Direction) {
    Direction[Direction["UP"] = 0] = "UP";
    Direction[Direction["DOWN"] = 1] = "DOWN";
    Direction[Direction["LEFT"] = 2] = "LEFT";
    Direction[Direction["RIGHT"] = 3] = "RIGHT";
})(Direction || (Direction = {}));
/**
 * Should be added to entities for which outer distance should be displayed.
 * Holds which directions the measurements should be displayed for.
 * Also holds directions that should not be displayed if the distance is to the room.
 * @param disabled - if the measurements should be displayed to the user or not
 */
class DistanceMeasurementComponent {
    constructor(directions, omitIfRoom, measureCloserToWall, disabled) {
        this.typeId = DistanceMeasurementComponent.id;
        this.directions = [];
        this.omitIfRoom = [];
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.disabled = false;
        this.directions = directions;
        this.omitIfRoom = omitIfRoom || [];
        this.measureCloserToWall = measureCloserToWall;
        this.disabled = !!disabled;
    }
    eq() {
        return false;
    }
}
DistanceMeasurementComponent.id = 2093;
export default DistanceMeasurementComponent;
//# sourceMappingURL=DistanceMeasurementComponent.js.map